import z from "zod"

export interface EventWebsiteResponse {
  id?: unknown
  eventVaultId?: unknown
  domainKey?: unknown
  slug?: unknown
  isPublic?: unknown
  dateCreated?: unknown
  lastUpdated?: unknown
}

export interface EventWebsiteData {
  eventVaultId?: number
  slug: string
  domainKey: string
  isPublic: boolean
  dateCreated?: Date
  lastUpdated?: Date
}

// Response schema for the guestpix-api create/update website endpoints. The
// backend (EventWebsiteDTO) only returns domainKey, slug and timestamps — it
// does NOT return id, eventVaultId or isPublic. The public toggle is sourced
// separately from the event vault (which maps EventWebsite.IsPublic).
export const EventWebsiteSchemaV1 = z.object({
  domainKey: z.string(),
  slug: z.string(),
  dateCreated: z.coerce.date().optional(),
  lastUpdated: z.coerce.date().optional(),
})

export type EventWebsiteDTOData = z.infer<typeof EventWebsiteSchemaV1>
